import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tenant-page" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "tenant-container" }
const _hoisted_5 = {
  class: "tenant-sidebar",
  style: {"width":"500px"}
}
const _hoisted_6 = {
  key: 0,
  class: "tenant-content"
}
const _hoisted_7 = { class: "tenant-basic-info" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "oem-config" }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = { class: "tenant-url" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "tenant-actions" }
const _hoisted_18 = { class: "auth-info" }
const _hoisted_19 = { class: "auth-tabs" }
const _hoisted_20 = { class: "auth-table" }
const _hoisted_21 = { class: "auth-table" }
const _hoisted_22 = { class: "auth-actions" }
const _hoisted_23 = { class: "app-list" }
const _hoisted_24 = { class: "operation-bar" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "subscription-list" }
const _hoisted_27 = { class: "operation-bar" }
const _hoisted_28 = { class: "system-config" }
const _hoisted_29 = { class: "config-section" }
const _hoisted_30 = { class: "config-section" }
const _hoisted_31 = { class: "config-section" }
const _hoisted_32 = { class: "config-section" }
const _hoisted_33 = { class: "config-section" }
const _hoisted_34 = { class: "config-section" }
const _hoisted_35 = { class: "config-section" }
const _hoisted_36 = { class: "form-actions" }
const _hoisted_37 = {
  key: 0,
  class: "pagination-container"
}

import { ref, reactive, computed, onMounted, watch } from 'vue'
import { tenantList as tenantData, Tenant, App, Subscription } from '../data/tenantData'

// 组件初始化时执行

const __default__ = {
  name: 'TenantManager'
}

interface OemConfig {
  loginTitleCn: string
  loginTitleEn: string
  workspace: string
  publicMenu: string
  loginBg: string
  mainInfo: string
  icpNumber: string
  policeRecord: string
  loginBackground: string
}

// 编辑应用

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(() => {
  // 默认选中第一个租户
  if (tenantList.value.length > 0 && !selectedTenant.value) {
    selectedTenant.value = tenantList.value[0]
    selectedKeys.value = [tenantList.value[0].id.toString()]
  }
})

// 搜索文本
const searchText = ref('')
// 当前激活的标签页
const activeTabKey = ref('basic')
// 当前选中的菜单项
const selectedKeys = ref<string[]>([])

// 租户列表数据
const tenantList = ref<Tenant[]>(tenantData)

// 当前选中的租户
const selectedTenant = ref<Tenant | null>(null)

// 编辑模式状态
const isEditing = ref(false)

// 分页配置
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
  showTotal: (total: number) => `共 ${total} 条记录`,
  showSizeChanger: true,
  showQuickJumper: true
})

// 分页后的租户数据
const paginatedTenants = computed(() => {
  const start = (pagination.current - 1) * pagination.pageSize
  const end = start + pagination.pageSize
  
  // 使用过滤后的租户列表
  const filtered = filteredTenants.value
  pagination.total = filtered.length
  
  return filtered.slice(start, end)
})

// 处理表格变化
const handleTableChange = (pag: any) => {
  pagination.current = pag.current
  pagination.pageSize = pag.pageSize
}

// OEM配置数据
const oemConfig = reactive<OemConfig>({
  loginTitleCn: '',
  loginTitleEn: '',
  workspace: '',
  publicMenu: '',
  loginBg: '',
  mainInfo: '',
  icpNumber: '',
  policeRecord: '',
  loginBackground: ''
})

// 文件上传列表
const fileList = ref([])
const bgFileList = ref([])

// 过滤后的租户列表
const filteredTenants = computed(() => {
  if (!searchText.value) {
    return tenantList.value
  }
  
  const searchLower = searchText.value.toLowerCase()
  return tenantList.value.filter(tenant => {
    return tenant.name.toLowerCase().includes(searchLower) || 
           tenant.code.toLowerCase().includes(searchLower)
  })
})

// 搜索处理
const onSearch = (value: string) => {
  console.log('search:', value)
  // 重置到第一页
  pagination.current = 1
  
  // 如果找到匹配的租户，选中第一个
  if (filteredTenants.value.length > 0) {
    selectedTenant.value = { ...filteredTenants.value[0] }
    selectedKeys.value = [filteredTenants.value[0].id.toString()]
    activeTabKey.value = 'basic'
  }
}

// 添加新租户
const addNewTenant = () => {
  // 实现添加新租户的逻辑
}

// 查看租户详情
const viewTenant = (record: Tenant) => {
  selectedTenant.value = record
  selectedKeys.value = [record.id.toString()]
  // 重置标签页为基础信息
  activeTabKey.value = 'basic'
}

// 处理表格行点击
const onRowClick = (record: Tenant) => {
  // 创建一个新对象来确保响应式更新
  selectedTenant.value = { ...record }
  selectedKeys.value = [record.id.toString()]
  // 重置标签页为基础信息
  activeTabKey.value = 'basic'
  
  // 添加日志以便调试
  console.log('选中租户:', selectedTenant.value)
}

// 编辑租户
const editTenant = (record: Tenant) => {
  console.log('编辑租户:', record)
  isEditing.value = true
}

// 取消编辑
const cancelEdit = () => {
  isEditing.value = false
}

// 保存租户信息
const saveTenant = () => {
  // 实现保存租户信息的逻辑
  console.log('保存租户信息:', selectedTenant.value)
  // 保存成功后退出编辑模式
  isEditing.value = false
}

// 删除租户
const deleteTenant = (record: Tenant) => {
  // 实现删除租户的逻辑
  console.log('删除租户:', record)
  // 从列表中移除租户
  tenantList.value = tenantList.value.filter(item => item.id !== record.id)
  // 如果删除的是当前选中的租户，则选中第一个租户
  if (selectedTenant.value && selectedTenant.value.id === record.id) {
    if (tenantList.value.length > 0) {
      selectedTenant.value = tenantList.value[0]
      selectedKeys.value = [tenantList.value[0].id.toString()]
    } else {
      selectedTenant.value = null
      selectedKeys.value = []
    }
  }
}

// 复制URL
const copyUrl = () => {
  // 实现复制URL的逻辑
  const url = `https://plant.cdn.meritar.com/app/core/#/?tenantcode=${selectedTenant.value?.code || 'default'}`
  navigator.clipboard.writeText(url)
    .then(() => {
      // 可以添加提示复制成功的逻辑
      console.log('URL已复制到剪贴板')
    })
    .catch(err => {
      console.error('复制失败:', err)
    })
}

// 处理文件上传
const handleUpload = (options: any) => {
  // 实现文件上传逻辑
}

// 处理背景图片上传
const handleBgUpload = (options: any) => {
  // 实现背景图片上传逻辑
}

// 重置配置
const resetConfig = () => {
  // 实现重置配置的逻辑
}

// 保存配置
const saveConfig = () => {
  // 实现保存配置的逻辑
}
const authGroups = ref([
  { name: '角色管理', code: 'group1', description: '', checked: true },
  { name: '用户管理', code: 'group2', description: '', checked: true },
  { name: '租户管理', code: 'group3', description: '', checked: true },
  { name: '部门管理', code: 'group4', description: '', checked: true },
  { name: '任务管理', code: 'group5', description: '', checked: true },
  { name: '模块管理', code: 'group6', description: '', checked: true },
  { name: '通知配置', code: 'group7', description: '', checked: true },
  { name: '租户协议', code: 'group8', description: '', checked: true },
  { name: '拓展管理', code: 'group9', description: '', checked: true },
  { name: '授权管理', code: 'group10', description: '', checked: true },
])

// 智联网授权组数据
const iotAuthGroups = ref([
  { name: '设备管理', code: 'iot1', description: '管理智联网设备', checked: true },
  { name: '产品管理', code: 'iot2', description: '管理智联网产品', checked: true },
  { name: '协议管理', code: 'iot3', description: '管理智联网协议', checked: true },
  { name: '数据分析', code: 'iot4', description: '智联网数据分析', checked: true },
  { name: '告警管理', code: 'iot5', description: '智联网告警管理', checked: true },
])

// 保存授权设置
const saveAuth = () => {
  // 实现保存授权的逻辑
  console.log('保存授权设置:', {
    basic: authGroups.value,
    iot: iotAuthGroups.value
  })
  // 可以添加保存成功的提示
}
// 租户应用列表数据
const appList = ref<App[]>([])

// 监听selectedTenant变化，更新appList
watch(() => selectedTenant.value, (newTenant) => {
  if (newTenant && newTenant.apps) {
    appList.value = [...newTenant.apps]
  } else {
    appList.value = []
  }
}, { immediate: true })


// OEM配置接口定义已经在导入的类型中定义

// OEM配置接口定义
const editApp = (record: any) => {
  // 实现编辑应用的逻辑
  console.log('编辑应用:', record)
  currentApp.value = { ...record }
  showAppDialog.value = true
}

// 删除应用
const deleteApp = (record: any) => {
  // 实现删除应用的逻辑
  console.log('删除应用:', record)
  appList.value = appList.value.filter(item => item.id !== record.id)
}
// 新增应用对话框的显示状态
const showAppDialog = ref(false)
// 当前编辑的应用数据
const currentApp = ref({
  id:'',
  name: '',
  appId: '', // 变量名改为appId
  secretKey: '',
  createTime: '',
  creator: ''
})

// 打开新增应用对话框
const addNewApp = () => {
  currentApp.value = {
    id:'',
    name: '',
    appId: '',
    secretKey: '',
    createTime: new Date().toLocaleString(),
    creator: '当前用户'
  }
  showAppDialog.value = true
}

// 保存应用
const saveApp = () => {
  if (!selectedTenant.value) return
  
  // 确保租户有apps属性
  if (!selectedTenant.value.apps) {
    selectedTenant.value.apps = []
  }
  
  // 编辑现有应用
  if (currentApp.value.appId) {
    const index = selectedTenant.value.apps.findIndex(app => app.id === currentApp.value.appId)
    if (index !== -1) {
      selectedTenant.value.apps[index] = { ...currentApp.value }
    }
  } 
  // 添加新应用
  else {
    const newApp = {
      ...currentApp.value,
      id: Date.now().toString(), // 生成唯一ID
      createTime: new Date().toLocaleString(),
      creator: '当前用户' // 这里应该使用实际的当前登录用户
    }
    selectedTenant.value.apps.push(newApp)
  }

  // 删除应用
const deleteApp = (record: any) => {
  if (!selectedTenant.value || !selectedTenant.value.apps) return
  
  selectedTenant.value.apps = selectedTenant.value.apps.filter(app => app.id !== record.id)
}
  
  showAppDialog.value = false
  // 重置当前应用
  currentApp.value = {
    id:'',
    name: '',
    appId: '',
    secretKey: '',
    createTime: '',
    creator: ''
  }
}

// 系统配置数据
const systemConfig = reactive({
  defaultRole: 'user', // 默认选择普通用户
  weatherKey: '',
  notifyUsers: [],
  checkUserLogout: false,
  singleSession: false,
  logRetention: 'forever',
  loginLogRetention: 'forever'
})

// 保存系统配置
const saveSystemConfig = () => {
  console.log('保存系统配置:', systemConfig)
  // 实现保存系统配置的逻辑
}

// 接口定义已经在导入的类型中

// ... existing code ...

// 租户订阅列表数据
const subscriptionList = computed(() => {
  if (!selectedTenant.value || !selectedTenant.value.subscriptions) {
    return []
  }
  return selectedTenant.value.subscriptions
})

// 新增订阅对话框的显示状态
const showSubscriptionDialog = ref(false)

// 当前编辑的订阅数据
const currentSubscription = ref({
  id:'',
  name: '',
  subscriptionId: '',
  accessKey: '',
  createTime: '',
  creator: ''
})

// 打开新增订阅对话框
const addNewSubscription = () => {
  currentSubscription.value = {
    id:'',
    name: '',
    subscriptionId: '',
    accessKey: '',
    createTime: new Date().toLocaleString(),
    creator: '当前用户'
  }
  showSubscriptionDialog.value = true
}

// 编辑订阅
const editSubscription = (record: any) => {
  console.log('编辑订阅:', record)
  currentSubscription.value = { ...record }
  showSubscriptionDialog.value = true
}

// 保存订阅
const saveSubscription = () => {
  if (!selectedTenant.value) return
  
  // 确保租户有subscriptions属性
  if (!selectedTenant.value.subscriptions) {
    selectedTenant.value.subscriptions = []
  }
  
  // 编辑现有订阅
  if (currentSubscription.value.subscriptionId) {
    const index = selectedTenant.value.subscriptions.findIndex(sub => sub.id === currentSubscription.value.subscriptionId)
    if (index !== -1) {
      selectedTenant.value.subscriptions[index] = { ...currentSubscription.value }
    }
  } 
  // 添加新订阅
  else {
    const newSubscription = {
      ...currentSubscription.value,
      id: Date.now().toString(), // 生成唯一ID
      createTime: new Date().toLocaleString(),
      creator: '当前用户' // 这里应该使用实际的当前登录用户
    }
    selectedTenant.value.subscriptions.push(newSubscription)
  }
  
  showSubscriptionDialog.value = false
  // 重置当前订阅
  currentSubscription.value = {
    id:'',
    name: '',
    subscriptionId: '',
    accessKey: '',
    createTime: '',
    creator: ''
  }
}

// 删除订阅
const deleteSubscription = (record: any) => {
  if (!selectedTenant.value || !selectedTenant.value.subscriptions) return
  
  selectedTenant.value.subscriptions = selectedTenant.value.subscriptions.filter(sub => sub.id !== record.id)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_input_search, {
                value: searchText.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                placeholder: "租户名称/租户编码",
                style: {"width":"300px"},
                onSearch: onSearch
              }, null, 8, ["value"]),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[43] || (_cache[43] = [
                  _createTextVNode("查 询")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: addNewTenant
            }, {
              default: _withCtx(() => _cache[44] || (_cache[44] = [
                _createTextVNode("+ 新增租户")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "tenant-list-header" }, "租户列表", -1)),
              _createVNode(_component_a_table, {
                dataSource: paginatedTenants.value,
                onChange: handleTableChange,
                pagination: false,
                "show-header": false,
                "row-key": "id",
                customRow: (record) => ({
              onClick: () => onRowClick(record),
            }),
                rowClassName: (record) => record.id === (selectedTenant.value?.id || '') ? 'ant-table-row-selected' : ''
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table_column, {
                    title: "租户名称",
                    "data-index": "name"
                  })
                ]),
                _: 1
              }, 8, ["dataSource", "customRow", "rowClassName"])
            ]),
            (selectedTenant.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_tabs, {
                    activeKey: activeTabKey.value,
                    "onUpdate:activeKey": _cache[28] || (_cache[28] = ($event: any) => ((activeTabKey).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "basic",
                        tab: "租户信息"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _cache[46] || (_cache[46] = _createElementVNode("h3", null, "租户基础信息", -1)),
                            (!isEditing.value)
                              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                                  key: 0,
                                  bordered: "",
                                  column: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "租户名称",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.name || '联星平台'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "租户Code",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.code || 'default'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "租户描述",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.description || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "创建时间",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.createTime || '2023-05-02 11:33:06'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "管理员昵称",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.adminName || 'administrator'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "管理员账号",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.adminAccount || 'administrator'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "管理员邮箱",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.adminEmail || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "管理员电话",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedTenant.value?.adminPhone || '-'), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_form, {
                                  key: 1,
                                  model: selectedTenant.value,
                                  layout: "vertical"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(_component_a_form_item, { label: "租户名称" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.name,
                                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedTenant.value.name) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "租户Code" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.code,
                                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedTenant.value.code) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "租户描述" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.description,
                                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((selectedTenant.value.description) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(_component_a_form_item, {
                                        label: "创建时间",
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.createTime,
                                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((selectedTenant.value.createTime) = $event)),
                                            disabled: ""
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "管理员昵称" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.adminName,
                                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((selectedTenant.value.adminName) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "管理员账号" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.adminAccount,
                                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((selectedTenant.value.adminAccount) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_component_a_form_item, { label: "管理员邮箱" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.adminEmail,
                                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((selectedTenant.value.adminEmail) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "管理员电话" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: selectedTenant.value.adminPhone,
                                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((selectedTenant.value.adminPhone) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["model"]))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[51] || (_cache[51] = _createElementVNode("h3", null, "OEM配置", -1)),
                            (!isEditing.value)
                              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                                  key: 0,
                                  bordered: "",
                                  column: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "登录页中文标题",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.loginTitleCn || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "登录页英文标题",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.loginTitleEn || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "登录页背景颜色",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.loginBg || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "主体信息",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.mainInfo || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "公安备案号",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.policeRecord || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "ICP备案号",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(oemConfig.icpNumber || '-'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "登录页背景",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_upload, {
                                          fileList: bgFileList.value,
                                          "onUpdate:fileList": _cache[9] || (_cache[9] = ($event: any) => ((bgFileList).value = $event)),
                                          customRequest: handleBgUpload,
                                          showUploadList: false
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_button, null, {
                                              default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                _createTextVNode("选择文件")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["fileList"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_descriptions_item, {
                                      label: "LOGO上传",
                                      span: 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_upload, {
                                          fileList: fileList.value,
                                          "onUpdate:fileList": _cache[10] || (_cache[10] = ($event: any) => ((fileList).value = $event)),
                                          customRequest: handleUpload,
                                          showUploadList: false
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_button, null, {
                                              default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                _createTextVNode("选择文件")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["fileList"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_form, {
                                  key: 1,
                                  model: oemConfig,
                                  layout: "vertical"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_a_form_item, { label: "登录页中文标题" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.loginTitleCn,
                                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((oemConfig.loginTitleCn) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "登录页英文标题" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.loginTitleEn,
                                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((oemConfig.loginTitleEn) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "登录页背景颜色" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.loginBg,
                                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((oemConfig.loginBg) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_a_form_item, { label: "主体信息" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.mainInfo,
                                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((oemConfig.mainInfo) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "公安备案号" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.policeRecord,
                                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((oemConfig.policeRecord) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "ICP备案号" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: oemConfig.icpNumber,
                                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((oemConfig.icpNumber) = $event))
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_component_a_form_item, { label: "登录页背景" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_upload, {
                                            fileList: bgFileList.value,
                                            "onUpdate:fileList": _cache[17] || (_cache[17] = ($event: any) => ((bgFileList).value = $event)),
                                            customRequest: handleBgUpload,
                                            showUploadList: true
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, null, {
                                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                  _createTextVNode("选择文件")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["fileList"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, { label: "LOGO上传" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_upload, {
                                            fileList: fileList.value,
                                            "onUpdate:fileList": _cache[18] || (_cache[18] = ($event: any) => ((fileList).value = $event)),
                                            customRequest: handleUpload,
                                            showUploadList: true
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, null, {
                                                default: _withCtx(() => _cache[50] || (_cache[50] = [
                                                  _createTextVNode("选择文件")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["fileList"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["model"]))
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _cache[53] || (_cache[53] = _createElementVNode("span", null, "租户访问地址：", -1)),
                            _createElementVNode("a", {
                              href: `https://platform.cdn.meritar.com/app/core/#/?tenantcode=${selectedTenant.value?.code || 'default'}`,
                              target: "_blank"
                            }, " https://platform.cdn.meritar.com/app/core/#/?tenantcode=" + _toDisplayString(selectedTenant.value?.code || 'default'), 9, _hoisted_16),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              class: "copy-btn",
                              size: "small",
                              onClick: copyUrl
                            }, {
                              default: _withCtx(() => _cache[52] || (_cache[52] = [
                                _createTextVNode("复制链接")
                              ])),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (!isEditing.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (editTenant(selectedTenant.value)))
                                  }, {
                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                      _createTextVNode("编辑")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "确定要删除这个租户吗？",
                                    "ok-text": "确定",
                                    "cancel-text": "取消",
                                    onConfirm: _cache[20] || (_cache[20] = ($event: any) => (deleteTenant(selectedTenant.value)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, { danger: "" }, {
                                        default: _withCtx(() => _cache[55] || (_cache[55] = [
                                          _createTextVNode("删除")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: saveTenant
                                  }, {
                                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                                      _createTextVNode("保存")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_button, { onClick: cancelEdit }, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode("取消")
                                    ])),
                                    _: 1
                                  })
                                ], 64))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "auth",
                        tab: "租户授权信息"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_a_tabs, { "default-active-key": "basic" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_tab_pane, {
                                    key: "basic",
                                    tab: "基础"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_component_a_table, {
                                          dataSource: authGroups.value,
                                          pagination: false,
                                          "row-key": "code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_table_column, {
                                              title: "",
                                              width: "50px"
                                            }, {
                                              default: _withCtx(({ record }) => [
                                                _createVNode(_component_a_checkbox, {
                                                  checked: record.checked,
                                                  "onUpdate:checked": ($event: any) => ((record.checked) = $event)
                                                }, null, 8, ["checked", "onUpdate:checked"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "名称",
                                              "data-index": "name"
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "授权code",
                                              "data-index": "code"
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "描述",
                                              "data-index": "description"
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["dataSource"])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_tab_pane, {
                                    key: "iot",
                                    tab: "智联网"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_a_table, {
                                          dataSource: iotAuthGroups.value,
                                          pagination: false,
                                          "row-key": "code"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_table_column, {
                                              title: "",
                                              width: "50px"
                                            }, {
                                              default: _withCtx(({ record }) => [
                                                _createVNode(_component_a_checkbox, {
                                                  checked: record.checked,
                                                  "onUpdate:checked": ($event: any) => ((record.checked) = $event)
                                                }, null, 8, ["checked", "onUpdate:checked"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "名称",
                                              "data-index": "name"
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "授权code",
                                              "data-index": "code"
                                            }),
                                            _createVNode(_component_a_table_column, {
                                              title: "描述",
                                              "data-index": "description"
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["dataSource"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: saveAuth
                              }, {
                                default: _withCtx(() => _cache[58] || (_cache[58] = [
                                  _createTextVNode("保存授权")
                                ])),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "app",
                        tab: "租户应用管理"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: addNewApp
                              }, {
                                default: _withCtx(() => _cache[59] || (_cache[59] = [
                                  _createTextVNode("+ 新增应用")
                                ])),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_a_table, {
                              dataSource: appList.value,
                              pagination: false,
                              "row-key": "id"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_table_column, {
                                  title: "应用名称",
                                  "data-index": "name"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "AppID",
                                  "data-index": "appId"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "SecretKey",
                                  "data-index": "secretKey"
                                }, {
                                  default: _withCtx(({ record }) => [
                                    _createTextVNode(_toDisplayString(record.secretKey ? '********' + record.secretKey.slice(-4) : ''), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "创建时间",
                                  "data-index": "createTime"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "创建人",
                                  "data-index": "creator"
                                }),
                                _createVNode(_component_a_table_column, { title: "操作" }, {
                                  default: _withCtx(({ record }) => [
                                    _createVNode(_component_a_space, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (editApp(record))
                                        }, "编辑", 8, _hoisted_25),
                                        _createVNode(_component_a_popconfirm, {
                                          title: "确定要删除这个应用吗？",
                                          "ok-text": "确定",
                                          "cancel-text": "取消",
                                          onConfirm: ($event: any) => (deleteApp(record))
                                        }, {
                                          default: _withCtx(() => _cache[60] || (_cache[60] = [
                                            _createElementVNode("a", null, "删除", -1)
                                          ])),
                                          _: 2
                                        }, 1032, ["onConfirm"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["dataSource"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "subscription",
                        tab: "订阅应用管理"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: addNewSubscription
                              }, {
                                default: _withCtx(() => _cache[61] || (_cache[61] = [
                                  _createTextVNode("+ 新增订阅")
                                ])),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_a_table, {
                              dataSource: subscriptionList.value,
                              pagination: false,
                              "row-key": "id"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_table_column, {
                                  title: "订阅名称",
                                  "data-index": "name"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "订阅ID",
                                  "data-index": "subscriptionId"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "访问密钥",
                                  "data-index": "accessKey"
                                }, {
                                  default: _withCtx(({ record }) => [
                                    _createTextVNode(_toDisplayString(record.accessKey ? '********' + record.accessKey.slice(-4) : ''), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "创建时间",
                                  "data-index": "createTime"
                                }),
                                _createVNode(_component_a_table_column, {
                                  title: "创建人",
                                  "data-index": "creator"
                                }),
                                _createVNode(_component_a_table_column, { title: "操作" }, {
                                  default: _withCtx(({ record }) => [
                                    _createVNode(_component_a_space, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_popconfirm, {
                                          title: "确定要承这个订阅吗？",
                                          "ok-text": "确定",
                                          "cancel-text": "取消",
                                          onConfirm: ($event: any) => (deleteSubscription(record))
                                        }, {
                                          default: _withCtx(() => _cache[62] || (_cache[62] = [
                                            _createElementVNode("a", null, "取消订阅", -1)
                                          ])),
                                          _: 2
                                        }, 1032, ["onConfirm"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["dataSource"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "system",
                        tab: "系统配置"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_a_form, {
                              model: systemConfig,
                              layout: "vertical"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_29, [
                                  _cache[66] || (_cache[66] = _createElementVNode("h3", null, "注册分配的角色", -1)),
                                  _createVNode(_component_a_select, {
                                    value: systemConfig.defaultRole,
                                    "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((systemConfig.defaultRole) = $event)),
                                    style: {"width":"100%"},
                                    placeholder: "普通用户"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select_option, { value: "user" }, {
                                        default: _withCtx(() => _cache[63] || (_cache[63] = [
                                          _createTextVNode("普通用户")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "admin" }, {
                                        default: _withCtx(() => _cache[64] || (_cache[64] = [
                                          _createTextVNode("管理员")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "superadmin" }, {
                                        default: _withCtx(() => _cache[65] || (_cache[65] = [
                                          _createTextVNode("超级管理员")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _cache[67] || (_cache[67] = _createElementVNode("h3", null, "和风天气秘钥", -1)),
                                  _createVNode(_component_a_input, {
                                    value: systemConfig.weatherKey,
                                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((systemConfig.weatherKey) = $event))
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _cache[68] || (_cache[68] = _createElementVNode("h3", null, "同步反馈通知用户", -1)),
                                  _createVNode(_component_a_select, {
                                    value: systemConfig.notifyUsers,
                                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((systemConfig.notifyUsers) = $event)),
                                    mode: "multiple",
                                    style: {"width":"100%"},
                                    placeholder: "请选择用户"
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _cache[71] || (_cache[71] = _createElementVNode("h3", null, "是否检查用户注销", -1)),
                                  _createVNode(_component_a_radio_group, {
                                    value: systemConfig.checkUserLogout,
                                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((systemConfig.checkUserLogout) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio, { value: true }, {
                                        default: _withCtx(() => _cache[69] || (_cache[69] = [
                                          _createTextVNode("禁止项目管理员注销账号")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_radio, { value: false }, {
                                        default: _withCtx(() => _cache[70] || (_cache[70] = [
                                          _createTextVNode("允许项目管理员注销账号")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[74] || (_cache[74] = _createElementVNode("h3", null, "启用单会话登录", -1)),
                                  _createVNode(_component_a_radio_group, {
                                    value: systemConfig.singleSession,
                                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((systemConfig.singleSession) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio, { value: true }, {
                                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                                          _createTextVNode("启用")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_radio, { value: false }, {
                                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                                          _createTextVNode("禁用")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _cache[77] || (_cache[77] = _createElementVNode("h3", null, "操作日志保留时间", -1)),
                                  _createVNode(_component_a_radio_group, {
                                    value: systemConfig.logRetention,
                                    "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((systemConfig.logRetention) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio, { value: "forever" }, {
                                        default: _withCtx(() => _cache[75] || (_cache[75] = [
                                          _createTextVNode("永久")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_radio, { value: "custom" }, {
                                        default: _withCtx(() => _cache[76] || (_cache[76] = [
                                          _createTextVNode("自定义")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _cache[80] || (_cache[80] = _createElementVNode("h3", null, "登陆日志保留时间", -1)),
                                  _createVNode(_component_a_radio_group, {
                                    value: systemConfig.loginLogRetention,
                                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((systemConfig.loginLogRetention) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_radio, { value: "forever" }, {
                                        default: _withCtx(() => _cache[78] || (_cache[78] = [
                                          _createTextVNode("永久")
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_radio, { value: "custom" }, {
                                        default: _withCtx(() => _cache[79] || (_cache[79] = [
                                          _createTextVNode("自定义")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: saveSystemConfig
                                  }, {
                                    default: _withCtx(() => _cache[81] || (_cache[81] = [
                                      _createTextVNode("保存")
                                    ])),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["model"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["activeKey"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (tenantList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_a_pagination, {
                  current: pagination.current,
                  "onUpdate:current": _cache[29] || (_cache[29] = ($event: any) => ((pagination.current) = $event)),
                  pageSize: pagination.pageSize,
                  "onUpdate:pageSize": _cache[30] || (_cache[30] = ($event: any) => ((pagination.pageSize) = $event)),
                  total: pagination.total,
                  "show-total": pagination.showTotal,
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  onChange: handleTableChange
                }, null, 8, ["current", "pageSize", "total", "show-total"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: showAppDialog.value,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((showAppDialog).value = $event)),
      title: "新增应用",
      onOk: saveApp
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: currentApp.value,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "应用名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentApp.value.name,
                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((currentApp.value.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "AppID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentApp.value.appId,
                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((currentApp.value.appId) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "SecretKey" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: currentApp.value.secretKey,
                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((currentApp.value.secretKey) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: showAppDialog.value,
      "onUpdate:visible": _cache[38] || (_cache[38] = ($event: any) => ((showAppDialog).value = $event)),
      title: "新增应用",
      onOk: saveApp
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: currentApp.value,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "应用名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentApp.value.name,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((currentApp.value.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "AppID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentApp.value.appId,
                  "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((currentApp.value.appId) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "SecretKey" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: currentApp.value.secretKey,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((currentApp.value.secretKey) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: showSubscriptionDialog.value,
      "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((showSubscriptionDialog).value = $event)),
      title: "新增订阅",
      onOk: saveSubscription
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: currentSubscription.value,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "订阅名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentSubscription.value.name,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((currentSubscription.value.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "订阅ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: currentSubscription.value.subscriptionId,
                  "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((currentSubscription.value.subscriptionId) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "访问密钥" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: currentSubscription.value.accessKey,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((currentSubscription.value.accessKey) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})